import { useState } from "react";
import { Nav } from "./Nav";
import { type Me, signOut } from "./session";
import type { ScreenId } from "./screens/types";
import { DashboardScreen } from "./screens/DashboardScreen";
import { OrdersScreen } from "./screens/OrdersScreen";
import { StockScreen } from "./screens/StockScreen";
import { CatalogScreen } from "./screens/CatalogScreen";
import { UsersScreen } from "./screens/UsersScreen";
import { RunScreen } from "./screens/RunScreen";
import { FailureConfigScreen } from "./screens/FailureConfigScreen";

/** The authenticated-admin shell (#257): header + nav + the active screen.
 *  #258-261 filled in Orders/Stock/Catalog/Users; #262 (ADR 0064) adds Run +
 *  Failure config, absorbed from the retired load-generator-ui. */
export function Shell({ me }: { me: Me }) {
  const [screen, setScreen] = useState<ScreenId>("dashboard");

  return (
    <div className="page">
      <header className="site-header">
        <div className="site-header-text">
          <h1>Admin</h1>
          <p className="tagline">Manage the store — catalog, inventory, orders, users.</p>
        </div>
        <div className="site-header-actions">
          <span className="signed-in">
            {me.name || me.email || me.sub}
            <button type="button" className="signout-link" onClick={() => signOut("/")}>
              Sign out
            </button>
          </span>
        </div>
      </header>

      <Nav current={screen} onSelect={setScreen} />

      <main>
        {screen === "dashboard" && <DashboardScreen me={me} />}
        {screen === "orders" && <OrdersScreen />}
        {screen === "stock" && <StockScreen />}
        {screen === "catalog" && <CatalogScreen />}
        {screen === "users" && <UsersScreen />}
        {screen === "run" && <RunScreen />}
        {screen === "failureConfig" && <FailureConfigScreen />}
      </main>
    </div>
  );
}
